import moment from "moment";

export default {
    data() {
        return {
            menuLayouts: [
                { id: 1, name: 'Main Menu', icon: '' },
                // { id: 2, name: 'Footer menu', icon: '' },
                { id: 3, name: 'Footer Menu (Column 1)', icon: '' },
                { id: 4, name: 'Footer Menu (Column 2)', icon: '' },
            ],
            pageStatuses: [
                { id: 2, name: 'Draft' },
                { id: 1, name: 'Published' },
            ],
            postStatuses: [
                { id: 2, name: 'Draft' },
                { id: 1, name: 'Published' },
            ],
            formStatuses: [
                { id: 2, name: 'Draft' },
                { id: 1, name: 'Published' },
            ],
            dataBlocksStatuses: [
                { id: 2, name: 'Draft' },
                { id: 1, name: 'Published' },
            ],
            nonRemovablePages: [
                'home',
                'about',
                'contacts',
                'blog',
                'events',
                'facts',
                'links',
                'downloads',
                'join',
                'store',
                'members',
                'library-catalog',
                'query-desk',
                'knowledge-base',
                'udm'
            ],
            factViews: [
                { id: 2, name: 'Members only' },
                { id: 1, name: 'Public' },
            ],
            linkViews: [
                { id: 2, name: 'Members only' },
                { id: 1, name: 'Public' },
            ],
            linkTypes: [
                { id: 2, name: 'EMAIL' },
                { id: 1, name: 'URL' },
            ],
            fileViews: [
                { id: 2, name: 'Members only' },
                { id: 1, name: 'Public' },
            ],
            storeCategoryViews: [
                { id: 2, name: 'Members Only' },
                { id: 1, name: 'Publicly Available' },
            ],
            chargeTypes: [
                { id: 1, name: 'Base Shipping Rate ONLY' },
                { id: 2, name: 'Item Specific Rate PLUS Base' },
            ],
            userTypes: [
                { id: 2, name: 'Organization' },
                { id: 1, name: 'Personal' },
            ],
            memberTypes: [
                { id: 2, name: 'Organization' },
                { id: 1, name: 'Personal' },
                { id: 3, name: 'Personal & Organization' },
            ],
            boolList: [
                { id: false, name: 'No' },
                { id: true, name: 'Yes' },
            ],
            months: [
                { value: '01', text: 'January' },
                { value: '02', text: 'February' },
                { value: '03', text: 'March' },
                { value: '04', text: 'April' },
                { value: '05', text: 'May' },
                { value: '06', text: 'June' },
                { value: '07', text: 'July' },
                { value: '08', text: 'August' },
                { value: '09', text: 'September' },
                { value: '10', text: 'October' },
                { value: '11', text: 'November' },
                { value: '12', text: 'December' },
            ],
            fontSizes: [
                { value: 10, text: '10px' },
                { value: 12, text: '12px' },
                { value: 14, text: '14px' },
                { value: 16, text: '16px' },
                { value: 18, text: '18px' },
                { value: 20, text: '20px' },
                { value: 22, text: '22px' },
                { value: 24, text: '24px' },
                { value: 26, text: '26px' },
                { value: 28, text: '28px' },
                { value: 30, text: '30px' },
                { value: 32, text: '32px' },
                { value: 34, text: '34px' },
                { value: 36, text: '36px' },
                { value: 38, text: '38px' },
                { value: 40, text: '40px' },
                { value: 42, text: '42px' },
            ],
            logoSizes: [
                { value: 'auto', text: 'Auto' },
                { value: 50, text: '50px' },
                { value: 100, text: '100px' },
                { value: 150, text: '150px' },
                { value: 200, text: '200px' },
                { value: 250, text: '250px' },
            ],
            heroSectionDelays: [
                { value: 5000, text: '5s' },
                { value: 10000, text: '10s' },
                { value: 15000, text: '15s' },
                { value: 20000, text: '20s' },
            ],
            seasonList: [
                { value: 'spring', text: 'Spring' },
                { value: 'summer', text: 'Summer' },
                { value: 'fall', text: 'Fall' },
                { value: 'winter', text: 'Winter' }
            ],
            userHistoryStatuses: [
                { value: 1, text: 'Unpaid' },
                { value: 2, text: 'Paid' },
                { value: 3, text: 'Voided' },
                { value: 4, text: 'Updated' },
                { value: 5, text: 'Uncollectible' },
            ],
            timezones: [
                {value: "GMT", text: "(GMT/UTC + 00:00) GMT"},
                {value: "UTC", text: "(GMT/UTC + 00:00) UTC"},
                {value: "Africa/Abidjan", text: "(GMT/UTC + 00:00) Abidjan"},
                {value: "Africa/Accra", text: "(GMT/UTC + 00:00) Accra"},
                {value: "Africa/Addis_Ababa", text: "(GMT/UTC + 03:00) Addis Ababa"},
                {value: "Africa/Algiers", text: "(GMT/UTC + 01:00) Algiers"},
                {value: "Africa/Asmara", text: "(GMT/UTC + 03:00) Asmara"},
                {value: "Africa/Bamako", text: "(GMT/UTC + 00:00) Bamako"},
                {value: "Africa/Bangui", text: "(GMT/UTC + 01:00) Bangui"},
                {value: "Africa/Banjul", text: "(GMT/UTC + 00:00) Banjul"},
                {value: "Africa/Bissau", text: "(GMT/UTC + 00:00) Bissau"},
                {value: "Africa/Blantyre", text: "(GMT/UTC + 02:00) Blantyre"},
                {value: "Africa/Brazzaville", text: "(GMT/UTC + 01:00) Brazzaville"},
                {value: "Africa/Bujumbura", text: "(GMT/UTC + 02:00) Bujumbura"},
                {value: "Africa/Cairo", text: "(GMT/UTC + 02:00) Cairo"},
                {value: "Africa/Casablanca", text: "(GMT/UTC + 01:00) Casablanca"},
                {value: "Africa/Ceuta", text: "(GMT/UTC + 01:00) Ceuta"},
                {value: "Africa/Conakry", text: "(GMT/UTC + 00:00) Conakry"},
                {value: "Africa/Dakar", text: "(GMT/UTC + 00:00) Dakar"},
                {value: "Africa/Dar_es_Salaam", text: "(GMT/UTC + 03:00) Dar es Salaam"},
                {value: "Africa/Djibouti", text: "(GMT/UTC + 03:00) Djibouti"},
                {value: "Africa/Douala", text: "(GMT/UTC + 01:00) Douala"},
                {value: "Africa/El_Aaiun", text: "(GMT/UTC + 01:00) El Aaiun"},
                {value: "Africa/Freetown", text: "(GMT/UTC + 00:00) Freetown"},
                {value: "Africa/Gaborone", text: "(GMT/UTC + 02:00) Gaborone"},
                {value: "Africa/Harare", text: "(GMT/UTC + 02:00) Harare"},
                {value: "Africa/Johannesburg", text: "(GMT/UTC + 02:00) Johannesburg"},
                {value: "Africa/Juba", text: "(GMT/UTC + 02:00) Juba"},
                {value: "Africa/Kampala", text: "(GMT/UTC + 03:00) Kampala"},
                {value: "Africa/Khartoum", text: "(GMT/UTC + 02:00) Khartoum"},
                {value: "Africa/Kigali", text: "(GMT/UTC + 02:00) Kigali"},
                {value: "Africa/Kinshasa", text: "(GMT/UTC + 01:00) Kinshasa"},
                {value: "Africa/Lagos", text: "(GMT/UTC + 01:00) Lagos"},
                {value: "Africa/Libreville", text: "(GMT/UTC + 01:00) Libreville"},
                {value: "Africa/Lome", text: "(GMT/UTC + 00:00) Lome"},
                {value: "Africa/Luanda", text: "(GMT/UTC + 01:00) Luanda"},
                {value: "Africa/Lubumbashi", text: "(GMT/UTC + 02:00) Lubumbashi"},
                {value: "Africa/Lusaka", text: "(GMT/UTC + 02:00) Lusaka"},
                {value: "Africa/Malabo", text: "(GMT/UTC + 01:00) Malabo"},
                {value: "Africa/Maputo", text: "(GMT/UTC + 02:00) Maputo"},
                {value: "Africa/Maseru", text: "(GMT/UTC + 02:00) Maseru"},
                {value: "Africa/Mbabane", text: "(GMT/UTC + 02:00) Mbabane"},
                {value: "Africa/Mogadishu", text: "(GMT/UTC + 03:00) Mogadishu"},
                {value: "Africa/Monrovia", text: "(GMT/UTC + 00:00) Monrovia"},
                {value: "Africa/Nairobi", text: "(GMT/UTC + 03:00) Nairobi"},
                {value: "Africa/Ndjamena", text: "(GMT/UTC + 01:00) Ndjamena"},
                {value: "Africa/Niamey", text: "(GMT/UTC + 01:00) Niamey"},
                {value: "Africa/Nouakchott", text: "(GMT/UTC + 00:00) Nouakchott"},
                {value: "Africa/Ouagadougou", text: "(GMT/UTC + 00:00) Ouagadougou"},
                {value: "Africa/Porto-Novo", text: "(GMT/UTC + 01:00) Porto-Novo"},
                {value: "Africa/Sao_Tome", text: "(GMT/UTC + 00:00) Sao Tome"},
                {value: "Africa/Tripoli", text: "(GMT/UTC + 02:00) Tripoli"},
                {value: "Africa/Tunis", text: "(GMT/UTC + 01:00) Tunis"},
                {value: "Africa/Windhoek", text: "(GMT/UTC + 02:00) Windhoek"},
                {value: "America/Adak", text: "(GMT/UTC - 10:00) Adak"},
                {value: "America/Anchorage", text: "(GMT/UTC - 09:00) Anchorage"},
                {value: "America/Anguilla", text: "(GMT/UTC - 04:00) Anguilla"},
                {value: "America/Antigua", text: "(GMT/UTC - 04:00) Antigua"},
                {value: "America/Araguaina", text: "(GMT/UTC - 03:00) Araguaina"},
                {value: "America/Argentina/Buenos_Aires", text: "(GMT/UTC - 03:00) Argentina / Buenos Aires"},
                {value: "America/Argentina/Catamarca", text: "(GMT/UTC - 03:00) Argentina / Catamarca"},
                {value: "America/Argentina/Cordoba", text: "(GMT/UTC - 03:00) Argentina / Cordoba"},
                {value: "America/Argentina/Jujuy", text: "(GMT/UTC - 03:00) Argentina / Jujuy"},
                {value: "America/Argentina/La_Rioja", text: "(GMT/UTC - 03:00) Argentina / La Rioja"},
                {value: "America/Argentina/Mendoza", text: "(GMT/UTC - 03:00) Argentina / Mendoza"},
                {value: "America/Argentina/Rio_Gallegos", text: "(GMT/UTC - 03:00) Argentina / Rio Gallegos"},
                {value: "America/Argentina/Salta", text: "(GMT/UTC - 03:00) Argentina / Salta"},
                {value: "America/Argentina/San_Juan", text: "(GMT/UTC - 03:00) Argentina / San Juan"},
                {value: "America/Argentina/San_Luis", text: "(GMT/UTC - 03:00) Argentina / San Luis"},
                {value: "America/Argentina/Tucuman", text: "(GMT/UTC - 03:00) Argentina / Tucuman"},
                {value: "America/Argentina/Ushuaia", text: "(GMT/UTC - 03:00) Argentina / Ushuaia"},
                {value: "America/Aruba", text: "(GMT/UTC - 04:00) Aruba"},
                {value: "America/Asuncion", text: "(GMT/UTC - 03:00) Asuncion"},
                {value: "America/Atikokan", text: "(GMT/UTC - 05:00) Atikokan"},
                {value: "America/Bahia", text: "(GMT/UTC - 03:00) Bahia"},
                {value: "America/Bahia_Banderas", text: "(GMT/UTC - 06:00) Bahia Banderas"},
                {value: "America/Barbados", text: "(GMT/UTC - 04:00) Barbados"},
                {value: "America/Belem", text: "(GMT/UTC - 03:00) Belem"},
                {value: "America/Belize", text: "(GMT/UTC - 06:00) Belize"},
                {value: "America/Blanc-Sablon", text: "(GMT/UTC - 04:00) Blanc-Sablon"},
                {value: "America/Boa_Vista", text: "(GMT/UTC - 04:00) Boa Vista"},
                {value: "America/Bogota", text: "(GMT/UTC - 05:00) Bogota"},
                {value: "America/Boise", text: "(GMT/UTC - 07:00) Boise"},
                {value: "America/Cambridge_Bay", text: "(GMT/UTC - 07:00) Cambridge Bay"},
                {value: "America/Campo_Grande", text: "(GMT/UTC - 04:00) Campo Grande"},
                {value: "America/Cancun", text: "(GMT/UTC - 05:00) Cancun"},
                {value: "America/Caracas", text: "(GMT/UTC - 04:00) Caracas"},
                {value: "America/Cayenne", text: "(GMT/UTC - 03:00) Cayenne"},
                {value: "America/Cayman", text: "(GMT/UTC - 05:00) Cayman"},
                {value: "America/Chicago", text: "(GMT/UTC - 06:00) Chicago"},
                {value: "America/Chihuahua", text: "(GMT/UTC - 06:00) Chihuahua"},
                {value: "America/Ciudad_Juarez", text: "(GMT/UTC - 07:00) Ciudad Juarez"},
                {value: "America/Costa_Rica", text: "(GMT/UTC - 06:00) Costa Rica"},
                {value: "America/Creston", text: "(GMT/UTC - 07:00) Creston"},
                {value: "America/Cuiaba", text: "(GMT/UTC - 04:00) Cuiaba"},
                {value: "America/Curacao", text: "(GMT/UTC - 04:00) Curacao"},
                {value: "America/Danmarkshavn", text: "(GMT/UTC + 00:00) Danmarkshavn"},
                {value: "America/Dawson", text: "(GMT/UTC - 07:00) Dawson"},
                {value: "America/Dawson_Creek", text: "(GMT/UTC - 07:00) Dawson Creek"},
                {value: "America/Denver", text: "(GMT/UTC - 07:00) Denver"},
                {value: "America/Detroit", text: "(GMT/UTC - 05:00) Detroit"},
                {value: "America/Dominica", text: "(GMT/UTC - 04:00) Dominica"},
                {value: "America/Edmonton", text: "(GMT/UTC - 07:00) Edmonton"},
                {value: "America/El_Salvador", text: "(GMT/UTC - 06:00) El Salvador"},
                {value: "America/Fort_Nelson", text: "(GMT/UTC - 07:00) Fort Nelson"},
                {value: "America/Fortaleza", text: "(GMT/UTC - 03:00) Fortaleza"},
                {value: "America/Glace_Bay", text: "(GMT/UTC - 04:00) Glace Bay"},
                {value: "America/Goose_Bay", text: "(GMT/UTC - 04:00) Goose Bay"},
                {value: "America/Grand_Turk", text: "(GMT/UTC - 05:00) Grand Turk"},
                {value: "America/Grenada", text: "(GMT/UTC - 04:00) Grenada"},
                {value: "America/Guadeloupe", text: "(GMT/UTC - 04:00) Guadeloupe"},
                {value: "America/Guatemala", text: "(GMT/UTC - 06:00) Guatemala"},
                {value: "America/Guayaquil", text: "(GMT/UTC - 05:00) Guayaquil"},
                {value: "America/Guyana", text: "(GMT/UTC - 04:00) Guyana"},
                {value: "America/Halifax", text: "(GMT/UTC - 04:00) Halifax"},
                {value: "America/Havana", text: "(GMT/UTC - 05:00) Havana"},
                {value: "America/Hermosillo", text: "(GMT/UTC - 07:00) Hermosillo"},
                {value: "America/Indiana/Indianapolis", text: "(GMT/UTC - 05:00) Indiana / Indianapolis"},
                {value: "America/Indiana/Knox", text: "(GMT/UTC - 06:00) Indiana / Knox"},
                {value: "America/Indiana/Marengo", text: "(GMT/UTC - 05:00) Indiana / Marengo"},
                {value: "America/Indiana/Petersburg", text: "(GMT/UTC - 05:00) Indiana / Petersburg"},
                {value: "America/Indiana/Tell_City", text: "(GMT/UTC - 06:00) Indiana / Tell City"},
                {value: "America/Indiana/Vevay", text: "(GMT/UTC - 05:00) Indiana / Vevay"},
                {value: "America/Indiana/Vincennes", text: "(GMT/UTC - 05:00) Indiana / Vincennes"},
                {value: "America/Indiana/Winamac", text: "(GMT/UTC - 05:00) Indiana / Winamac"},
                {value: "America/Inuvik", text: "(GMT/UTC - 07:00) Inuvik"},
                {value: "America/Iqaluit", text: "(GMT/UTC - 05:00) Iqaluit"},
                {value: "America/Jamaica", text: "(GMT/UTC - 05:00) Jamaica"},
                {value: "America/Juneau", text: "(GMT/UTC - 09:00) Juneau"},
                {value: "America/Kentucky/Louisville", text: "(GMT/UTC - 05:00) Kentucky / Louisville"},
                {value: "America/Kentucky/Monticello", text: "(GMT/UTC - 05:00) Kentucky / Monticello"},
                {value: "America/Kralendijk", text: "(GMT/UTC - 04:00) Kralendijk"},
                {value: "America/La_Paz", text: "(GMT/UTC - 04:00) La Paz"},
                {value: "America/Lima", text: "(GMT/UTC - 05:00) Lima"},
                {value: "America/Los_Angeles", text: "(GMT/UTC - 08:00) Los Angeles"},
                {value: "America/Lower_Princes", text: "(GMT/UTC - 04:00) Lower Princes"},
                {value: "America/Maceio", text: "(GMT/UTC - 03:00) Maceio"},
                {value: "America/Managua", text: "(GMT/UTC - 06:00) Managua"},
                {value: "America/Manaus", text: "(GMT/UTC - 04:00) Manaus"},
                {value: "America/Marigot", text: "(GMT/UTC - 04:00) Marigot"},
                {value: "America/Martinique", text: "(GMT/UTC - 04:00) Martinique"},
                {value: "America/Matamoros", text: "(GMT/UTC - 06:00) Matamoros"},
                {value: "America/Mazatlan", text: "(GMT/UTC - 07:00) Mazatlan"},
                {value: "America/Menominee", text: "(GMT/UTC - 06:00) Menominee"},
                {value: "America/Merida", text: "(GMT/UTC - 06:00) Merida"},
                {value: "America/Metlakatla", text: "(GMT/UTC - 09:00) Metlakatla"},
                {value: "America/Mexico_City", text: "(GMT/UTC - 06:00) Mexico City"},
                {value: "America/Miquelon", text: "(GMT/UTC - 03:00) Miquelon"},
                {value: "America/Moncton", text: "(GMT/UTC - 04:00) Moncton"},
                {value: "America/Monterrey", text: "(GMT/UTC - 06:00) Monterrey"},
                {value: "America/Montevideo", text: "(GMT/UTC - 03:00) Montevideo"},
                {value: "America/Montserrat", text: "(GMT/UTC - 04:00) Montserrat"},
                {value: "America/Nassau", text: "(GMT/UTC - 05:00) Nassau"},
                {value: "America/New_York", text: "(GMT/UTC - 05:00) New York"},
                {value: "America/Nome", text: "(GMT/UTC - 09:00) Nome"},
                {value: "America/Noronha", text: "(GMT/UTC - 02:00) Noronha"},
                {value: "America/North_Dakota/Beulah", text: "(GMT/UTC - 06:00) North Dakota / Beulah"},
                {value: "America/North_Dakota/Center", text: "(GMT/UTC - 06:00) North Dakota / Center"},
                {value: "America/North_Dakota/New_Salem", text: "(GMT/UTC - 06:00) North Dakota / New Salem"},
                {value: "America/Nuuk", text: "(GMT/UTC - 02:00) Nuuk"},
                {value: "America/Ojinaga", text: "(GMT/UTC - 06:00) Ojinaga"},
                {value: "America/Panama", text: "(GMT/UTC - 05:00) Panama"},
                {value: "America/Paramaribo", text: "(GMT/UTC - 03:00) Paramaribo"},
                {value: "America/Phoenix", text: "(GMT/UTC - 07:00) Phoenix"},
                {value: "America/Port-au-Prince", text: "(GMT/UTC - 05:00) Port-au-Prince"},
                {value: "America/Port_of_Spain", text: "(GMT/UTC - 04:00) Port of Spain"},
                {value: "America/Porto_Velho", text: "(GMT/UTC - 04:00) Porto Velho"},
                {value: "America/Puerto_Rico", text: "(GMT/UTC - 04:00) Puerto Rico"},
                {value: "America/Punta_Arenas", text: "(GMT/UTC - 03:00) Punta Arenas"},
                {value: "America/Rankin_Inlet", text: "(GMT/UTC - 06:00) Rankin Inlet"},
                {value: "America/Recife", text: "(GMT/UTC - 03:00) Recife"},
                {value: "America/Regina", text: "(GMT/UTC - 06:00) Regina"},
                {value: "America/Resolute", text: "(GMT/UTC - 06:00) Resolute"},
                {value: "America/Rio_Branco", text: "(GMT/UTC - 05:00) Rio Branco"},
                {value: "America/Santarem", text: "(GMT/UTC - 03:00) Santarem"},
                {value: "America/Santiago", text: "(GMT/UTC - 03:00) Santiago"},
                {value: "America/Santo_Domingo", text: "(GMT/UTC - 04:00) Santo Domingo"},
                {value: "America/Sao_Paulo", text: "(GMT/UTC - 03:00) Sao Paulo"},
                {value: "America/Scoresbysund", text: "(GMT/UTC - 01:00) Scoresbysund"},
                {value: "America/Sitka", text: "(GMT/UTC - 09:00) Sitka"},
                {value: "America/St_Barthelemy", text: "(GMT/UTC - 04:00) St. Barthelemy"},
                {value: "America/St_Johns", text: "(GMT/UTC - 03:30) St. Johns"},
                {value: "America/St_Kitts", text: "(GMT/UTC - 04:00) St. Kitts"},
                {value: "America/St_Lucia", text: "(GMT/UTC - 04:00) St. Lucia"},
                {value: "America/St_Thomas", text: "(GMT/UTC - 04:00) St. Thomas"},
                {value: "America/St_Vincent", text: "(GMT/UTC - 04:00) St. Vincent"},
                {value: "America/Swift_Current", text: "(GMT/UTC - 06:00) Swift Current"},
                {value: "America/Tegucigalpa", text: "(GMT/UTC - 06:00) Tegucigalpa"},
                {value: "America/Thule", text: "(GMT/UTC - 04:00) Thule"},
                {value: "America/Tijuana", text: "(GMT/UTC - 08:00) Tijuana"},
                {value: "America/Toronto", text: "(GMT/UTC - 05:00) Toronto"},
                {value: "America/Tortola", text: "(GMT/UTC - 04:00) Tortola"},
                {value: "America/Vancouver", text: "(GMT/UTC - 08:00) Vancouver"},
                {value: "America/Whitehorse", text: "(GMT/UTC - 07:00) Whitehorse"},
                {value: "America/Winnipeg", text: "(GMT/UTC - 06:00) Winnipeg"},
                {value: "America/Yakutat", text: "(GMT/UTC - 09:00) Yakutat"},
                {value: "Antarctica/Casey", text: "(GMT/UTC + 11:00) Casey"},
                {value: "Antarctica/Davis", text: "(GMT/UTC + 07:00) Davis"},
                {value: "Antarctica/DumontDUrville", text: "(GMT/UTC + 10:00) DumontDUrville"},
                {value: "Antarctica/Macquarie", text: "(GMT/UTC + 11:00) Macquarie"},
                {value: "Antarctica/Mawson", text: "(GMT/UTC + 05:00) Mawson"},
                {value: "Antarctica/McMurdo", text: "(GMT/UTC + 13:00) McMurdo"},
                {value: "Antarctica/Palmer", text: "(GMT/UTC - 03:00) Palmer"},
                {value: "Antarctica/Rothera", text: "(GMT/UTC - 03:00) Rothera"},
                {value: "Antarctica/Syowa", text: "(GMT/UTC + 03:00) Syowa"},
                {value: "Antarctica/Troll", text: "(GMT/UTC + 00:00) Troll"},
                {value: "Antarctica/Vostok", text: "(GMT/UTC + 06:00) Vostok"},
                {value: "Arctic/Longyearbyen", text: "(GMT/UTC + 01:00) Longyearbyen"},
                {value: "Asia/Aden", text: "(GMT/UTC + 03:00) Aden"},
                {value: "Asia/Almaty", text: "(GMT/UTC + 06:00) Almaty"},
                {value: "Asia/Amman", text: "(GMT/UTC + 03:00) Amman"},
                {value: "Asia/Anadyr", text: "(GMT/UTC + 12:00) Anadyr"},
                {value: "Asia/Aqtau", text: "(GMT/UTC + 05:00) Aqtau"},
                {value: "Asia/Aqtobe", text: "(GMT/UTC + 05:00) Aqtobe"},
                {value: "Asia/Ashgabat", text: "(GMT/UTC + 05:00) Ashgabat"},
                {value: "Asia/Atyrau", text: "(GMT/UTC + 05:00) Atyrau"},
                {value: "Asia/Baghdad", text: "(GMT/UTC + 03:00) Baghdad"},
                {value: "Asia/Bahrain", text: "(GMT/UTC + 03:00) Bahrain"},
                {value: "Asia/Baku", text: "(GMT/UTC + 04:00) Baku"},
                {value: "Asia/Bangkok", text: "(GMT/UTC + 07:00) Bangkok"},
                {value: "Asia/Barnaul", text: "(GMT/UTC + 07:00) Barnaul"},
                {value: "Asia/Beirut", text: "(GMT/UTC + 02:00) Beirut"},
                {value: "Asia/Bishkek", text: "(GMT/UTC + 06:00) Bishkek"},
                {value: "Asia/Brunei", text: "(GMT/UTC + 08:00) Brunei"},
                {value: "Asia/Chita", text: "(GMT/UTC + 09:00) Chita"},
                {value: "Asia/Choibalsan", text: "(GMT/UTC + 08:00) Choibalsan"},
                {value: "Asia/Colombo", text: "(GMT/UTC + 05:30) Colombo"},
                {value: "Asia/Damascus", text: "(GMT/UTC + 03:00) Damascus"},
                {value: "Asia/Dhaka", text: "(GMT/UTC + 06:00) Dhaka"},
                {value: "Asia/Dili", text: "(GMT/UTC + 09:00) Dili"},
                {value: "Asia/Dubai", text: "(GMT/UTC + 04:00) Dubai"},
                {value: "Asia/Dushanbe", text: "(GMT/UTC + 05:00) Dushanbe"},
                {value: "Asia/Famagusta", text: "(GMT/UTC + 02:00) Famagusta"},
                {value: "Asia/Gaza", text: "(GMT/UTC + 02:00) Gaza"},
                {value: "Asia/Hebron", text: "(GMT/UTC + 02:00) Hebron"},
                {value: "Asia/Ho_Chi_Minh", text: "(GMT/UTC + 07:00) Ho Chi Minh"},
                {value: "Asia/Hong_Kong", text: "(GMT/UTC + 08:00) Hong Kong"},
                {value: "Asia/Hovd", text: "(GMT/UTC + 07:00) Hovd"},
                {value: "Asia/Irkutsk", text: "(GMT/UTC + 08:00) Irkutsk"},
                {value: "Asia/Jakarta", text: "(GMT/UTC + 07:00) Jakarta"},
                {value: "Asia/Jayapura", text: "(GMT/UTC + 09:00) Jayapura"},
                {value: "Asia/Jerusalem", text: "(GMT/UTC + 02:00) Jerusalem"},
                {value: "Asia/Kabul", text: "(GMT/UTC + 04:30) Kabul"},
                {value: "Asia/Kamchatka", text: "(GMT/UTC + 12:00) Kamchatka"},
                {value: "Asia/Karachi", text: "(GMT/UTC + 05:00) Karachi"},
                {value: "Asia/Kathmandu", text: "(GMT/UTC + 05:45) Kathmandu"},
                {value: "Asia/Khandyga", text: "(GMT/UTC + 09:00) Khandyga"},
                {value: "Asia/Kolkata", text: "(GMT/UTC + 05:30) Kolkata"},
                {value: "Asia/Krasnoyarsk", text: "(GMT/UTC + 07:00) Krasnoyarsk"},
                {value: "Asia/Kuala_Lumpur", text: "(GMT/UTC + 08:00) Kuala Lumpur"},
                {value: "Asia/Kuching", text: "(GMT/UTC + 08:00) Kuching"},
                {value: "Asia/Kuwait", text: "(GMT/UTC + 03:00) Kuwait"},
                {value: "Asia/Macau", text: "(GMT/UTC + 08:00) Macau"},
                {value: "Asia/Magadan", text: "(GMT/UTC + 11:00) Magadan"},
                {value: "Asia/Makassar", text: "(GMT/UTC + 08:00) Makassar"},
                {value: "Asia/Manila", text: "(GMT/UTC + 08:00) Manila"},
                {value: "Asia/Muscat", text: "(GMT/UTC + 04:00) Muscat"},
                {value: "Asia/Nicosia", text: "(GMT/UTC + 02:00) Nicosia"},
                {value: "Asia/Novokuznetsk", text: "(GMT/UTC + 07:00) Novokuznetsk"},
                {value: "Asia/Novosibirsk", text: "(GMT/UTC + 07:00) Novosibirsk"},
                {value: "Asia/Omsk", text: "(GMT/UTC + 06:00) Omsk"},
                {value: "Asia/Oral", text: "(GMT/UTC + 05:00) Oral"},
                {value: "Asia/Phnom_Penh", text: "(GMT/UTC + 07:00) Phnom Penh"},
                {value: "Asia/Pontianak", text: "(GMT/UTC + 07:00) Pontianak"},
                {value: "Asia/Pyongyang", text: "(GMT/UTC + 09:00) Pyongyang"},
                {value: "Asia/Qatar", text: "(GMT/UTC + 03:00) Qatar"},
                {value: "Asia/Qostanay", text: "(GMT/UTC + 06:00) Qostanay"},
                {value: "Asia/Qyzylorda", text: "(GMT/UTC + 05:00) Qyzylorda"},
                {value: "Asia/Riyadh", text: "(GMT/UTC + 03:00) Riyadh"},
                {value: "Asia/Sakhalin", text: "(GMT/UTC + 11:00) Sakhalin"},
                {value: "Asia/Samarkand", text: "(GMT/UTC + 05:00) Samarkand"},
                {value: "Asia/Seoul", text: "(GMT/UTC + 09:00) Seoul"},
                {value: "Asia/Shanghai", text: "(GMT/UTC + 08:00) Shanghai"},
                {value: "Asia/Singapore", text: "(GMT/UTC + 08:00) Singapore"},
                {value: "Asia/Srednekolymsk", text: "(GMT/UTC + 11:00) Srednekolymsk"},
                {value: "Asia/Taipei", text: "(GMT/UTC + 08:00) Taipei"},
                {value: "Asia/Tashkent", text: "(GMT/UTC + 05:00) Tashkent"},
                {value: "Asia/Tbilisi", text: "(GMT/UTC + 04:00) Tbilisi"},
                {value: "Asia/Tehran", text: "(GMT/UTC + 03:30) Tehran"},
                {value: "Asia/Thimphu", text: "(GMT/UTC + 06:00) Thimphu"},
                {value: "Asia/Tokyo", text: "(GMT/UTC + 09:00) Tokyo"},
                {value: "Asia/Tomsk", text: "(GMT/UTC + 07:00) Tomsk"},
                {value: "Asia/Ulaanbaatar", text: "(GMT/UTC + 08:00) Ulaanbaatar"},
                {value: "Asia/Urumqi", text: "(GMT/UTC + 06:00) Urumqi"},
                {value: "Asia/Ust-Nera", text: "(GMT/UTC + 10:00) Ust-Nera"},
                {value: "Asia/Vientiane", text: "(GMT/UTC + 07:00) Vientiane"},
                {value: "Asia/Vladivostok", text: "(GMT/UTC + 10:00) Vladivostok"},
                {value: "Asia/Yakutsk", text: "(GMT/UTC + 09:00) Yakutsk"},
                {value: "Asia/Yangon", text: "(GMT/UTC + 06:30) Yangon"},
                {value: "Asia/Yekaterinburg", text: "(GMT/UTC + 05:00) Yekaterinburg"},
                {value: "Asia/Yerevan", text: "(GMT/UTC + 04:00) Yerevan"},
                {value: "Atlantic/Azores", text: "(GMT/UTC - 01:00) Azores"},
                {value: "Atlantic/Bermuda", text: "(GMT/UTC - 04:00) Bermuda"},
                {value: "Atlantic/Canary", text: "(GMT/UTC + 00:00) Canary"},
                {value: "Atlantic/Cape_Verde", text: "(GMT/UTC - 01:00) Cape Verde"},
                {value: "Atlantic/Faroe", text: "(GMT/UTC + 00:00) Faroe"},
                {value: "Atlantic/Madeira", text: "(GMT/UTC + 00:00) Madeira"},
                {value: "Atlantic/Reykjavik", text: "(GMT/UTC + 00:00) Reykjavik"},
                {value: "Atlantic/South_Georgia", text: "(GMT/UTC - 02:00) South Georgia"},
                {value: "Atlantic/St_Helena", text: "(GMT/UTC + 00:00) St. Helena"},
                {value: "Atlantic/Stanley", text: "(GMT/UTC - 03:00) Stanley"},
                {value: "Australia/Adelaide", text: "(GMT/UTC + 10:30) Adelaide"},
                {value: "Australia/Brisbane", text: "(GMT/UTC + 10:00) Brisbane"},
                {value: "Australia/Broken_Hill", text: "(GMT/UTC + 10:30) Broken Hill"},
                {value: "Australia/Darwin", text: "(GMT/UTC + 09:30) Darwin"},
                {value: "Australia/Eucla", text: "(GMT/UTC + 08:45) Eucla"},
                {value: "Australia/Hobart", text: "(GMT/UTC + 11:00) Hobart"},
                {value: "Australia/Lindeman", text: "(GMT/UTC + 10:00) Lindeman"},
                {value: "Australia/Lord_Howe", text: "(GMT/UTC + 11:00) Lord Howe"},
                {value: "Australia/Melbourne", text: "(GMT/UTC + 11:00) Melbourne"},
                {value: "Australia/Perth", text: "(GMT/UTC + 08:00) Perth"},
                {value: "Australia/Sydney", text: "(GMT/UTC + 11:00) Sydney"},
                {value: "Europe/Amsterdam", text: "(GMT/UTC + 01:00) Amsterdam"},
                {value: "Europe/Andorra", text: "(GMT/UTC + 01:00) Andorra"},
                {value: "Europe/Astrakhan", text: "(GMT/UTC + 04:00) Astrakhan"},
                {value: "Europe/Athens", text: "(GMT/UTC + 02:00) Athens"},
                {value: "Europe/Belgrade", text: "(GMT/UTC + 01:00) Belgrade"},
                {value: "Europe/Berlin", text: "(GMT/UTC + 01:00) Berlin"},
                {value: "Europe/Bratislava", text: "(GMT/UTC + 01:00) Bratislava"},
                {value: "Europe/Brussels", text: "(GMT/UTC + 01:00) Brussels"},
                {value: "Europe/Bucharest", text: "(GMT/UTC + 02:00) Bucharest"},
                {value: "Europe/Budapest", text: "(GMT/UTC + 01:00) Budapest"},
                {value: "Europe/Busingen", text: "(GMT/UTC + 01:00) Busingen"},
                {value: "Europe/Chisinau", text: "(GMT/UTC + 02:00) Chisinau"},
                {value: "Europe/Copenhagen", text: "(GMT/UTC + 01:00) Copenhagen"},
                {value: "Europe/Dublin", text: "(GMT/UTC + 00:00) Dublin"},
                {value: "Europe/Gibraltar", text: "(GMT/UTC + 01:00) Gibraltar"},
                {value: "Europe/Guernsey", text: "(GMT/UTC + 00:00) Guernsey"},
                {value: "Europe/Helsinki", text: "(GMT/UTC + 02:00) Helsinki"},
                {value: "Europe/Isle_of_Man", text: "(GMT/UTC + 00:00) Isle of Man"},
                {value: "Europe/Istanbul", text: "(GMT/UTC + 03:00) Istanbul"},
                {value: "Europe/Jersey", text: "(GMT/UTC + 00:00) Jersey"},
                {value: "Europe/Kaliningrad", text: "(GMT/UTC + 02:00) Kaliningrad"},
                {value: "Europe/Kirov", text: "(GMT/UTC + 03:00) Kirov"},
                {value: "Europe/Kyiv", text: "(GMT/UTC + 02:00) Kyiv"},
                {value: "Europe/Lisbon", text: "(GMT/UTC + 00:00) Lisbon"},
                {value: "Europe/Ljubljana", text: "(GMT/UTC + 01:00) Ljubljana"},
                {value: "Europe/London", text: "(GMT/UTC + 00:00) London"},
                {value: "Europe/Luxembourg", text: "(GMT/UTC + 01:00) Luxembourg"},
                {value: "Europe/Madrid", text: "(GMT/UTC + 01:00) Madrid"},
                {value: "Europe/Malta", text: "(GMT/UTC + 01:00) Malta"},
                {value: "Europe/Mariehamn", text: "(GMT/UTC + 02:00) Mariehamn"},
                {value: "Europe/Minsk", text: "(GMT/UTC + 03:00) Minsk"},
                {value: "Europe/Monaco", text: "(GMT/UTC + 01:00) Monaco"},
                {value: "Europe/Moscow", text: "(GMT/UTC + 03:00) Moscow"},
                {value: "Europe/Oslo", text: "(GMT/UTC + 01:00) Oslo"},
                {value: "Europe/Paris", text: "(GMT/UTC + 01:00) Paris"},
                {value: "Europe/Podgorica", text: "(GMT/UTC + 01:00) Podgorica"},
                {value: "Europe/Prague", text: "(GMT/UTC + 01:00) Prague"},
                {value: "Europe/Riga", text: "(GMT/UTC + 02:00) Riga"},
                {value: "Europe/Rome", text: "(GMT/UTC + 01:00) Rome"},
                {value: "Europe/Samara", text: "(GMT/UTC + 04:00) Samara"},
                {value: "Europe/San_Marino", text: "(GMT/UTC + 01:00) San Marino"},
                {value: "Europe/Sarajevo", text: "(GMT/UTC + 01:00) Sarajevo"},
                {value: "Europe/Saratov", text: "(GMT/UTC + 04:00) Saratov"},
                {value: "Europe/Simferopol", text: "(GMT/UTC + 03:00) Simferopol"},
                {value: "Europe/Skopje", text: "(GMT/UTC + 01:00) Skopje"},
                {value: "Europe/Sofia", text: "(GMT/UTC + 02:00) Sofia"},
                {value: "Europe/Stockholm", text: "(GMT/UTC + 01:00) Stockholm"},
                {value: "Europe/Tallinn", text: "(GMT/UTC + 02:00) Tallinn"},
                {value: "Europe/Tirane", text: "(GMT/UTC + 01:00) Tirane"},
                {value: "Europe/Ulyanovsk", text: "(GMT/UTC + 04:00) Ulyanovsk"},
                {value: "Europe/Vaduz", text: "(GMT/UTC + 01:00) Vaduz"},
                {value: "Europe/Vatican", text: "(GMT/UTC + 01:00) Vatican"},
                {value: "Europe/Vienna", text: "(GMT/UTC + 01:00) Vienna"},
                {value: "Europe/Vilnius", text: "(GMT/UTC + 02:00) Vilnius"},
                {value: "Europe/Volgograd", text: "(GMT/UTC + 03:00) Volgograd"},
                {value: "Europe/Warsaw", text: "(GMT/UTC + 01:00) Warsaw"},
                {value: "Europe/Zagreb", text: "(GMT/UTC + 01:00) Zagreb"},
                {value: "Europe/Zurich", text: "(GMT/UTC + 01:00) Zurich"},
                {value: "Indian/Antananarivo", text: "(GMT/UTC + 03:00) Antananarivo"},
                {value: "Indian/Chagos", text: "(GMT/UTC + 06:00) Chagos"},
                {value: "Indian/Christmas", text: "(GMT/UTC + 07:00) Christmas"},
                {value: "Indian/Cocos", text: "(GMT/UTC + 06:30) Cocos"},
                {value: "Indian/Comoro", text: "(GMT/UTC + 03:00) Comoro"},
                {value: "Indian/Kerguelen", text: "(GMT/UTC + 05:00) Kerguelen"},
                {value: "Indian/Mahe", text: "(GMT/UTC + 04:00) Mahe"},
                {value: "Indian/Maldives", text: "(GMT/UTC + 05:00) Maldives"},
                {value: "Indian/Mauritius", text: "(GMT/UTC + 04:00) Mauritius"},
                {value: "Indian/Mayotte", text: "(GMT/UTC + 03:00) Mayotte"},
                {value: "Indian/Reunion", text: "(GMT/UTC + 04:00) Reunion"},
                {value: "Pacific/Apia", text: "(GMT/UTC + 13:00) Apia"},
                {value: "Pacific/Auckland", text: "(GMT/UTC + 13:00) Auckland"},
                {value: "Pacific/Bougainville", text: "(GMT/UTC + 11:00) Bougainville"},
                {value: "Pacific/Chatham", text: "(GMT/UTC + 13:45) Chatham"},
                {value: "Pacific/Chuuk", text: "(GMT/UTC + 10:00) Chuuk"},
                {value: "Pacific/Easter", text: "(GMT/UTC - 05:00) Easter"},
                {value: "Pacific/Efate", text: "(GMT/UTC + 11:00) Efate"},
                {value: "Pacific/Fakaofo", text: "(GMT/UTC + 13:00) Fakaofo"},
                {value: "Pacific/Fiji", text: "(GMT/UTC + 12:00) Fiji"},
                {value: "Pacific/Funafuti", text: "(GMT/UTC + 12:00) Funafuti"},
                {value: "Pacific/Galapagos", text: "(GMT/UTC - 06:00) Galapagos"},
                {value: "Pacific/Gambier", text: "(GMT/UTC - 09:00) Gambier"},
                {value: "Pacific/Guadalcanal", text: "(GMT/UTC + 11:00) Guadalcanal"},
                {value: "Pacific/Guam", text: "(GMT/UTC + 10:00) Guam"},
                {value: "Pacific/Honolulu", text: "(GMT/UTC - 10:00) Honolulu"},
                {value: "Pacific/Kanton", text: "(GMT/UTC + 13:00) Kanton"},
                {value: "Pacific/Kiritimati", text: "(GMT/UTC + 14:00) Kiritimati"},
                {value: "Pacific/Kosrae", text: "(GMT/UTC + 11:00) Kosrae"},
                {value: "Pacific/Kwajalein", text: "(GMT/UTC + 12:00) Kwajalein"},
                {value: "Pacific/Majuro", text: "(GMT/UTC + 12:00) Majuro"},
                {value: "Pacific/Marquesas", text: "(GMT/UTC - 09:30) Marquesas"},
                {value: "Pacific/Midway", text: "(GMT/UTC - 11:00) Midway"},
                {value: "Pacific/Nauru", text: "(GMT/UTC + 12:00) Nauru"},
                {value: "Pacific/Niue", text: "(GMT/UTC - 11:00) Niue"},
                {value: "Pacific/Norfolk", text: "(GMT/UTC + 12:00) Norfolk"},
                {value: "Pacific/Noumea", text: "(GMT/UTC + 11:00) Noumea"},
                {value: "Pacific/Pago_Pago", text: "(GMT/UTC - 11:00) Pago Pago"},
                {value: "Pacific/Palau", text: "(GMT/UTC + 09:00) Palau"},
                {value: "Pacific/Pitcairn", text: "(GMT/UTC - 08:00) Pitcairn"},
                {value: "Pacific/Pohnpei", text: "(GMT/UTC + 11:00) Pohnpei"},
                {value: "Pacific/Port_Moresby", text: "(GMT/UTC + 10:00) Port Moresby"},
                {value: "Pacific/Rarotonga", text: "(GMT/UTC - 10:00) Rarotonga"},
                {value: "Pacific/Saipan", text: "(GMT/UTC + 10:00) Saipan"},
                {value: "Pacific/Tahiti", text: "(GMT/UTC - 10:00) Tahiti"},
                {value: "Pacific/Tarawa", text: "(GMT/UTC + 12:00) Tarawa"},
                {value: "Pacific/Tongatapu", text: "(GMT/UTC + 13:00) Tongatapu"},
                {value: "Pacific/Wake", text: "(GMT/UTC + 12:00) Wake"},
                {value: "Pacific/Wallis", text: "(GMT/UTC + 12:00) Wallis"},
            ],
            paymentTypes: [
                { id: 'M', name: 'Cash', code: 'cash', value: 'Cash' },
                { id: 'C', name: 'Check with Mail-in Form', code: 'check', value: 'Check' },
                { id: 'P', name: 'PayPal / Credit Card', code: 'pay-pal', value: 'PayPal' },
                { id: 'S', name: 'Stripe / Credit Card / Digital Wallet', code: 'stripe', value: 'Stripe' },
            ],
            namePrefixes: [
                'Dr.',
                'Miss',
                'Mr.',
                'Mrs.',
                'Ms.',
            ],
            nameSuffixes: [
                'III',
                'M.D.',
                'Ph.D.',
                'Sr.',
                'Jr.',
            ],
            userPhoneFormats: [
                { value: 1, text: '(123) 456-7890' },
                { value: 2, text: '123-456-7890' },
                { value: 3, text: '123.456.7890' },
                { value: 4, text: '123-4567890' },
                { value: 5, text: '123/456-7890' },
                { value: 6, text: '+11234567890' },
            ],
            userPhoneFormatsMask: [
                { value: 1, text: '(###) ###-####' },
                { value: 2, text: '###-###-####' },
                { value: 3, text: '###.###.####' },
                { value: 4, text: '###-#######' },
                { value: 5, text: '###/###-####' },
                { value: 6, text: '+1##########' },
            ],
            partialYearTypes: [
                { value: 2, text: 'Include Days' },
                { value: 1, text: 'Not Used' },
                { value: 3, text: 'Reduced Fee' },
            ],
            formFieldTypes: [
                { value: 10, text: 'Checkbox' },
                { value: 7, text: 'Date' },
                { value: 3, text: 'Email' },
                { value: 1, text: 'Input' },
                { value: 8, text: 'List' },
                { value: 6, text: 'Number' },
                { value: 5, text: 'Phone' },
                { value: 9, text: 'Radio' },
                { value: 2, text: 'Text' },
                { value: 4, text: 'Url' }
            ],
            quotaMap: {
                256: '250 MB',
                512: '500 MB',
                768: '750 MB',
                1024: '1 GB',
                1280: '1.25 GB',
                1536: '1.5 GB',
                1792: '1.75 GB',
                2048: '2 GB',
                2304: '2.25 GB',
                2560: '2.5 GB',
                2816: '2.75 GB',
                3072: '3 GB',
                3328: '3.25 GB',
                3584: '3.5 GB',
                3840: '3.75 GB',
                4096: '4 GB',
                4352: '4.25 GB',
                4608: '4.5 GB',
                4864: '4.75 GB',
                5120: '5 GB',
            },
            inputsHints: {
                passwordHiding: 'Once entered, passwords can’t be seen. Enter a new password above if necessary.',
                passwordValidity: 'Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and number.',
                fiscalYear: 'The name of the fiscal year is the year ENDING date according to accounting standards.  For example, in 2026, a year that begins on any day later than January 1, will end the following year, and it will be FY 2027 when that start date arrives.',
            }
        }
    },
    methods: {
        isHomePageManu(item, groups) {
            if (!item.id) {
                return false;
            }

            let hasItem = false;

            for (let i = 0; i < groups.length; i++) {
                const group = groups[i];

                if (group.layout === 1 && group.items.filter(item => item.properties.url === 'page::1').length > 1) {
                    hasItem = true;

                    break;
                }
            }

            return !hasItem && item.layout === 1 && item.properties?.url === 'page::1';
        },
        monthList() {
            const list = [];
            for (let i = 0; i <= 11; i++) {
                list.push({
                    value: i + 1,
                    text: moment().month(i).format('MMMM')
                });
            }
            return list;
        },
        yearList(count) {
            const list = [];
            for (let i = 0; i <= count; i++) {
                list.push({
                    value: moment().add(-i, 'year').format('YYYY'),
                    text: moment().add(-i, 'year').format('YYYY')
                });
            }
            return list;
        },
        daysListByMonth(month) {
            const lastDay = moment(month, 'MM').daysInMonth();
            const list = [];
            for (let i = 1; i <= lastDay; i++) {
                list.push({
                    value: i,
                    text: i
                });
            }
            return list;
        },
        daysListByMonthPadded(month) {
            const lastDay = moment(month, 'MM').daysInMonth();
            const list = [];
            for (let i = 1; i <= lastDay; i++) {
                list.push({
                    value: i.toString().padStart(2, '0'),
                    text: i.toString().padStart(2, '0')
                });
            }
            return list;
        },
        generateNumbersList(length) {
            const list = [];
            for (let i = 1; i <= length; i++) {
                list.push({
                    value: i,
                    text: i
                });
            }
            return list;
        }
    }
}
